import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { Container } from "../../Container/Container/Container";
import { Background } from "../../Background/Background";
import { FloatyImage } from "../../FloatyImage/FloatyImage";
import { Text } from "../../Text/Text/Text";
import styles from "./TestimonialSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TestimonialSlice = function TestimonialSlice(_ref) {
  var text = _ref.text,
    author = _ref.author,
    _ref$subtext = _ref.subtext,
    subtext = _ref$subtext === void 0 ? '' : _ref$subtext,
    background = _ref.background,
    floatyImage = _ref.floatyImage;
  return /*#__PURE__*/_jsx("div", {
    className: styles.wrapper,
    children: /*#__PURE__*/_jsxs(Background, _objectSpread(_objectSpread({}, background), {}, {
      children: [/*#__PURE__*/_jsx(FloatyImage, _objectSpread({}, floatyImage)), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.content,
          children: [/*#__PURE__*/_jsx(Text, {
            className: styles.text,
            typog: "subhead1",
            children: "&ldquo;".concat(text, "&rdquo;")
          }, "text"), /*#__PURE__*/_jsx(Text, {
            className: styles.author,
            typog: "headline5",
            children: author
          }, "author"), /*#__PURE__*/_jsx(Text, {
            typog: "bodycopyLarge",
            children: subtext
          }, "subtext")]
        })
      })]
    }))
  });
};